import apis from "../../core/apis.js";

class CaptainPlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.captainPlan).get(options);
  }

  get(id) {
    return this.$resource(apis.captainPlan + id).get();
  }

  search(search = "") {
    return this.$resource(apis.captainPlan).get({ search });
  }

  post(item) {
    return this.$resource(apis.captainPlan).save(item);
  }

  activate(id) {
    return this.$resource(apis.captainPlan + id + "activate").save(id);
  }

  deactivate(id) {
    return this.$resource(apis.captainPlan + id + "deactivate").save(id);
  }

  update(id, item) {
    return this.$resource(apis.captainPlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default CaptainPlanResource;



// WEBPACK FOOTER //
// ./src/resources/captainPlan/captainPlan.resource.js